import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import counterSlice from "../feature/counterSlice/counterSlice";
import specializationSlice from "../feature/specializationSlice";
import apiReducer from "../feature/AuthSlice";
import addProjectReducer from "../feature/AddProjectSlice";

const persistConfig = {
  key: "root",
  storage,
};
// Remove the non-serializable value from the persisted reducer
const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    counter: counterSlice,
    specialization: specializationSlice.reducer,
    auth: apiReducer,
    addProject: addProjectReducer,
  })
);
export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export const persistor = persistStore(store);
